module.exports = __webpack_public_path__ + "static/img/47e502f6-594d-42cb-b0ee-849fc0d7d0b4.f096fa76.png";